import { render } from "./WCRadioButton.vue?vue&type=template&id=4af35054&scoped=true"
import script from "./WCRadioButton.vue?vue&type=script&lang=js"
export * from "./WCRadioButton.vue?vue&type=script&lang=js"

import "./WCRadioButton.vue?vue&type=style&index=0&id=4af35054&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af35054"]])

export default __exports__